import React from 'react'
import './Styles/Option.css'

const Content = (props) => {
    return (
        <div>
            {props.children}
        </div>
    )
}

export default Content